import React from 'react';
import Modal from '../components/bootstrap4/Modal';
import WeatherReport from '../components/modals/WeatherReport';
import EnvironmentalReport from '../components/modals/EnvironmentalReport';
import HumanPowerReport from '../components/modals/HumanPowerReport';
import StandardDailyReport from '../components/modals/StandardDailyReport';
import Tiles from './tiles';
import AfterHoursVisitorsReport from '../components/modals/AfterHoursVisitorsReport';
// import PPEAwarenessDailyReport from '../components/modals/PPEAwarenessDailyReport';
// import VehicleTrackingReport from '../components/modals/VehicleTrackingReport';
import RainReport from '../components/modals/RainReport';
import WindReport from '../components/modals/WindReport';
import UptimeReport from '../components/modals/UptimeReport';
// import { Link } from 'react-router-dom';
import SessionManager from '../routes/SessionManager';
import Loading from "../components/Loading"

function ReportsHome() {
    let sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');
    let zones = user.zones;

    const header = { label: "Reports", description: "These are some helpful reports that give you an overview of your site." };
    const label = <span className="cursor-pointer text-primary">View <i className="fa fa-angle-right"></i></span>;

    const reports = [{
        name: 'Weather Report',
        description: 'View how the weather was at your site for the last 7 days.',
        pic: <i name="darksky" className="fa fa-cloud-sun-rain" style={{ color: "rgb(95, 186, 224)" }}></i>,
        report: <Modal ref={React.createRef()} id="weatherReportModal" title="Weather Report (Weekly)" label={label} size="modal-lg"><WeatherReport title="Weather Weekly Report"></WeatherReport></Modal>
    },
    {
        name: 'Man Power Report',
        description: 'View how many people were at your site during each hour of a day.',
        pic: <i className="fa fa-users"></i>,
        report: <Modal ref={React.createRef()} id="manPowerReportModal" title="Man Power Report" label={label} size="modal-lg"><HumanPowerReport title="Man Power Report"></HumanPowerReport></Modal>
    }, {
        name: 'Standard Daily Report',
        description: 'View consolidated report of site information on any given date.',
        pic: <i className="fa fa-file-alt text-primary"></i>,
        report: <Modal ref={React.createRef()} id="stdDailyReportModal" title="Standard Daily Report" label={label} size="modal-lg"><StandardDailyReport title="Standard Daily Report"></StandardDailyReport></Modal>
    }, {
        name: "Environmental Daily Report",
        description: 'View environmental parameters of your site on any given date.',
        pic: <i className="fa fa-globe-americas text-success"></i>,
        report: <Modal ref={React.createRef()} id="environmentalDailyReportModal" title="Environmental Daily Report" label={label} size="modal-lg"><EnvironmentalReport title="Environmental Daily Report"></EnvironmentalReport></Modal>
    }, {
        name: "Environmental Weekly Report",
        description: 'View environmental parameters of your site for a week from any given date.',
        pic: <i className="fa fa-globe-americas text-success"></i>,
        report: <Modal ref={React.createRef()} id="environmentalWeeklyReportModal" title="Environmental Weekly Report" label={label} size="modal-lg"><EnvironmentalReport title="Environmental Weekly Report"></EnvironmentalReport></Modal>
    }, {
        name: "After-Hours Report",
        description: 'View details of after-hours people and vehicles and provide any comments.',
        pic: <i className="fas fa-clock"></i>,
        report: <Modal ref={React.createRef()} id="afterhoursvisitorsreport" title="After Hours Report" label={label} size="modal-lg"><AfterHoursVisitorsReport key={'afterhours-report'} title="After Hours Visitors Report"></AfterHoursVisitorsReport></Modal>
    },
    // {
    //     name: "PPE Awareness Daily Report",
    //     description: 'View details of PPE and of your site on any given date.',
    //     pic: <i className="fas fa-hard-hat text-warning"></i>,
    //     report: <Modal ref={React.createRef()} id="ppeawarenessdailyreport" title="PPE Awareness Daily Report" label={label} size="modal-lg"><PPEAwarenessDailyReport title="PPE Awareness Daily Report"></PPEAwarenessDailyReport></Modal>,
    //     savedReports: <Link className="pull-right" to='/ppe-reports-library'>Saved Reports <i className="fas fa-arrow-alt-circle-right"></i></Link>
    // },
    // {
    //     name: "Vehicle Tracking Report",
    //     description: 'View details of vehicle tracking report of your site.',
    //     pic: <i className="fas fa-car text-primary"></i>,
    //     report: <Modal ref={React.createRef()} id="vehicletrackingreport" title="Vehicle Tracking Report" label={label} size="modal-lg"><VehicleTrackingReport title="Vehicle Tracking Report"></VehicleTrackingReport></Modal>
    // },
    {
        name: "Rain Report",
        description: 'View details of Rain report of your site.',
        pic: <i className="fa fa-cloud-sun-rain" style={{ color: "rgb(95, 186, 224)" }}></i>,
        report: <Modal ref={React.createRef()} id="rainreport" title="Rain Report" label={label} size="modal-lg"><RainReport title="Rain Report"></RainReport></Modal>
    },
    {
        name: "Wind Report",
        description: 'View details of Wind report of your site.',
        pic: <i className='fas fa-wind' style={{ color: "#d9831f" }}></i>,
        report: <Modal ref={React.createRef()} id="windreport" title="Wind Report" label={label} size="modal-lg"><WindReport title="Rain Report"></WindReport></Modal>
    },
    {
        name: "Uptime Report",
        description: 'View details of uptime report of your site.',
        pic: <i className='fas fa-clock text-success' style={{ color: "#d9831f" }}></i>,
        report: <Modal ref={React.createRef()} id="uptimereport" title="Uptime Report" label={label} size="modal-lg"><UptimeReport title="Uptime And Accuracy Report"></UptimeReport></Modal>
    },
    {
        name: "Reports Library",
        description: 'View all the historical reports of your site for the given dates.',
        pic: <i className="fas fa-archive text-primary"></i>,
        report: <span className="cursor-pointer text-primary"><a className="text-primary" href='/reports/reports-library'>View <i className="fa fa-angle-right"></i></a></span>
    }
    ]

    return (
        <React.Fragment>
            {zones !== null ?
                <div className="page-container">
                    <Tiles header={header} reports={reports}></Tiles>
                </div> : <React.Fragment>
                    <div className="page-container">
                        <Loading>Fetching ... </Loading>
                    </div>
                </React.Fragment>}
        </React.Fragment >
    );
}

export default ReportsHome;